import BusinessesList from '@/views/Admin/BusinessesList/BusinessesList.vue';
import { Route } from '../route.model';

const adminBusinessesList = new Route(
  '/admin/businesses',
  'businesses_list',
  BusinessesList,
  {
    isResponsive: true,
    requiresAuth: true,
    superRoot: true,
    navbar: {
      name: 'Businesses', // TODO apply i18n
      icon: 'coin-rewarded'
    },
    zendesk: {
      disabled: true
    }
  }
);

export { adminBusinessesList };
export default adminBusinessesList;
